import React from 'react';
import PropTypes from 'prop-types';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { dateFormatter } from 'core/helpers/formatters';
import { getIncidentTypeLabel } from './helpers';
import { useStyles } from './confirm-remove-incidents-dialog.styles';

const ConfirmRemoveIncidentsDialog = ({ open, incidents, isAutoPolicy, onConfirm, onClose }) => {
  const classes = useStyles();

  const incidentCount = incidents.length;
  const title =
    incidentCount === 1
      ? 'Are you sure you want to remove this incident?'
      : `Are you sure you want to remove ${incidentCount} incidents?`;

  return (
    <BaseDialog size="md" open={open} onClose={onClose}>
      <Label type="greenBig">{title}</Label>
      <Label type="modalBody" className={classes.description}>
        {isAutoPolicy
          ? 'Removing an incident removes everything on its date, for every driver, and a later report pull can bring it back. These will be removed, and the policy premium will be recalculated:'
          : 'The following will be removed and the policy premium will be recalculated:'}
      </Label>
      <ul className={classes.incidentList}>
        {incidents.map((incident) => (
          <li key={incident.id}>
            {dateFormatter(incident.date)} &mdash; {incident.category === 'claim' ? 'Claim' : 'Violation'} (
            {getIncidentTypeLabel(incident.type)}){isAutoPolicy && incident.driver ? ` — ${incident.driver}` : ''}
          </li>
        ))}
      </ul>
      <div className={classes.buttonContainer}>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Remove {incidentCount === 1 ? 'Incident' : 'Incidents'}
        </Button>
        <Button variant="contained" color="secondary" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </BaseDialog>
  );
};

ConfirmRemoveIncidentsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  incidents: PropTypes.array.isRequired,
  isAutoPolicy: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ConfirmRemoveIncidentsDialog;
